import { eventBus } from './events';

const DEFAULT_DURATION_MS = 4000;

/**
 * Show a toast notification.
 * @param {string} message - The message to display
 * @param {number} [duration=DEFAULT_DURATION_MS] - Duration in milliseconds
 */
function show(message, duration = DEFAULT_DURATION_MS) {
  eventBus.$emit('toast', { message, duration });
}

export default {
  show,
};
